// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__2R4BM","skeleton_user":"Skeleton_skeleton_user__2NB-y","img":"Skeleton_img__3_4Vx","content":"Skeleton_content__1b-_c"};